const regexesValidation = {
  isNumber: /^-?\d+([.,]\d+)?$/g,
  isNumberPositiveOnly: /^\d+([.,]\d+)?$/g,
};

export default regexesValidation;
